/**
 * The Content-Security-Policy nonce for this page load.
 *
 * Production's CSP allows no inline styles (security audit: Weak CSP, no
 * 'unsafe-inline'). nginx puts a fresh random value in the policy header and,
 * through sub_filter, in index.html's csp-nonce meta tag; a <style> element is
 * applied only when it carries that value. Used by the emotion cache that
 * styles MUI (src/index.tsx) and by every <style> block a component renders:
 * `<style nonce={CSP_NONCE}>`.
 *
 * Undefined where nothing substitutes the placeholder (the dev server, which
 * sends no CSP), so nothing changes there.
 */
const value = document.querySelector<HTMLMetaElement>('meta[name="csp-nonce"]')?.content;

export const CSP_NONCE: string | undefined = value && value !== '__CSP_NONCE__' ? value : undefined;
